import type { AirQualityData } from "./air-quality";

/** Air quality is location-level (not sport-scoped); show it for every sport
 *  whenever cached data exists. The panel self-hides on null anyway. */
export function shouldShowAirQuality(airQuality: AirQualityData | null): boolean {
  return airQuality !== null;
}
